import { render, staticRenderFns } from "./PostConfirmEditPanel.vue?vue&type=template&id=03f3a1a7"
import script from "./PostConfirmEditPanel.vue?vue&type=script&lang=js"
export * from "./PostConfirmEditPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports